import { NavLink, Link, Outlet } from "react-router-dom";
import { Home, LayoutGrid, PlusCircle, Download, User } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import { Logo } from "@/components/common";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/explore", label: "Explore", icon: LayoutGrid },
  { to: "/seller/upload", label: "Sell", icon: PlusCircle, primary: true },
  { to: "/purchases", label: "Purchases", icon: Download },
  { to: "/profile", label: "Profile", icon: User },
];

function MobileNav() {
  return (
    <nav className="glass fixed inset-x-0 bottom-0 z-40 border-t pb-[env(safe-area-inset-bottom)] md:hidden" data-testid="mobile-bottom-nav">
      <div className="grid h-16 grid-cols-5">
        {ITEMS.map(({ to, label, icon: I, end, primary }) => (
          <NavLink key={to} to={to} end={end} data-testid={`mobile-nav-${label.toLowerCase()}`}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-1 text-[11px] font-medium ${isActive ? "text-primary" : "text-muted-foreground"}`}>
            {primary ? <span className="grid h-9 w-9 place-items-center rounded-full bg-primary text-white shadow-lg shadow-primary/40"><I size={18} /></span> : <I size={20} />}
            {!primary && label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="mt-24 border-t border-border">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo testid="footer-logo" />
          <p className="mt-4 max-w-sm text-sm text-muted-foreground">The marketplace for editable CorelDRAW, Photoshop, Illustrator and Canva templates.</p>
          <p className="eyebrow mt-6">Create. Sell. Download.</p>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-semibold">Marketplace</p>
          <Link to="/explore" className="block text-muted-foreground hover:text-foreground">Explore templates</Link>
          <Link to="/explore?sort=popular" className="block text-muted-foreground hover:text-foreground">Best sellers</Link>
          <Link to="/explore?format=CDR" className="block text-muted-foreground hover:text-foreground">CorelDRAW files</Link>
        </div>
        <div className="space-y-2 text-sm">
          <p className="font-semibold">Designers</p>
          <Link to="/seller" className="block text-muted-foreground hover:text-foreground">Become a seller</Link>
          <Link to="/seller/upload" className="block text-muted-foreground hover:text-foreground">Sell a template</Link>
          <Link to="/seller/wallet" className="block text-muted-foreground hover:text-foreground">Wallet & payouts</Link>
        </div>
      </div>
      <p className="border-t border-border py-6 text-center text-xs text-muted-foreground">© {new Date().getFullYear()} GrafixMarket. All rights reserved.</p>
    </footer>
  );
}

export default function AppLayout() {
  return (
    <div className="min-h-screen pb-20 md:pb-0">
      <Navbar />
      <main><Outlet /></main>
      <Footer />
      <MobileNav />
    </div>
  );
}
